export const SET_USER_OLD_FORM = "SET_USER_OLD_FORM";

export const setUserOldForm = (response) => {
  return {
    type: SET_USER_OLD_FORM,
    payload: response,
  };
};
